module.exports = __webpack_public_path__ + "static/media/Agrifood Stack Gateway - GBR Tech - 21-03-2025 C.b4211ad5.png";